'use strict';


var ad_modal = function () {
  var self = this;

  self.init();
};


ad_modal.prototype.init = function () {
  //var self = this;

  // console.log('init ad_modal');

  // jQuery(document).on(
  //     'click input propertychange',
  //     '.ad_textArea textarea',
  //     function (event) {

  //       var element = jQuery(this);

  //       if (element.hasClass('st_mounted') === false) {
  //         event.preventDefault();
  //         event.stopPropagation();

  //         autosize(element);

  //         element.addClass('st_mounted');
  //       }

  //     }
  // );

};


ad_modal.prototype.confirm = function (url, message) {
  //var self = this;

  var modalConfirm = jQuery('#ad_modalConfirm');

  var modalConfirm_message = modalConfirm.find('.ad_modal_confirmMessage');

  modalConfirm_message.html(message);

  modalConfirm.modal(
    {
      backdrop: 'static',
      keyboard: false
    }
  )
  .find('.ad_modal_el_confirmButton')
  .unbind( 'click' )
  .bind(
    'click',
    function (/*event*/) {
      event.preventDefault();
      event.stopPropagation();

      window.location.href = url;
    }
  );


};


ad_modal.prototype.confirm_form = function (message, trigger) {
  //var self = this;

  event.preventDefault();
  event.stopPropagation();

  var form = jQuery(trigger).closest('form');

  var modalConfirm = jQuery('#ad_modalConfirm');

  var modalConfirm_message = modalConfirm.find('.ad_modal_confirmMessage');

  modalConfirm_message.html(message);

  modalConfirm.modal(
    {
      backdrop: 'static',
      keyboard: false
    }
  )
  .find('.ad_modal_el_confirmButton')
  .unbind( 'click' )
  .bind(
    'click',
    function (localform/*event*/) {
      event.preventDefault();
      event.stopPropagation();

      localform.submit();

    }.bind(null, form) );

};

ad_modal.prototype.modal_ajax = function (ajax_url) {
  //var self = this;

  // console.log('modal_ajax');
  // console.log(ajax_url);

  jQuery.get( ajax_url, function( data ) {

    // Buscamos el modal
    var modal_ajax = jQuery('#ad_modalAjax');

    // buscamos el contenedor del contenido
    var modal_ajaxContent = modal_ajax.find('.ad_modal_ajaxContent');

    // Inyectamos el html recibido desde la llamada Ajax
    modal_ajaxContent.html(data);

    // Mostramos el modal de Ajax
    modal_ajax.modal(
      {
        backdrop: 'static',
        keyboard: false
      }
    );

  });

};







jQuery( document ).ready(function() {

  window.ad_modal = new ad_modal();

});



